import React, {Component} from 'react';
import TariffTypes from '../components/landing/tariffTypesLanding';
import TariffTypesMobile from '../components/landing/tariffTypesLandingMobile';
import TranslationService from "../service/TranslationService";
import {
    CHOOSE_CITY,
    CHOOSE_MUNICIPALITY,
    CHOOSE_TARIFF_MODEL,
    CHOOSE_CITY_MUNICIPALITY_TARIFF,
    CHOOSE_TARIFF
} from "../language-content/keys";
import Autocomplete from "react-autocomplete";
import '../extensions/StringExtensions'

class ChooseTariffModel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTariffType: null,
            tariffModels: []
        }
    }

    render() {

        return (
            <section id="main-wrapper">
                <div className="container h-100">
                    <div className="row h-100">
                        <div className="col-12">
                            <h4 class="text-white serif-bold text-center mb-md-5">{TranslationService.translate(CHOOSE_CITY_MUNICIPALITY_TARIFF, this.props.lang)}</h4>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-5 offset-xl-1">
                                    <h3 className="text-white serif-bold lead-text"> {TranslationService.translate(CHOOSE_CITY, this.props.lang)} </h3>
                                    <Autocomplete
                                        value={this.props.selectedCityName}
                                        onChange={(e) => this.props.setSelectedCityName(e.target.value)}
                                        onSelect={(value, item) => {
                                            this.props.selectCity(item.id)
                                        }}
                                        getItemValue={(item) => item.label}
                                        items={this.props.autocompleteCities.map(c => {
                                            return {id: c.id, label: this.translateName(c)}
                                        })}
                                        renderItem={(item, isHighlighted) =>
                                            <div className="p-1" key={'city' + item.id}
                                                 style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                                                <span style={{paddingLeft: "8px"}}> {item.label} </span>
                                            </div>
                                        }
                                        renderInput={(inputProps) => (
                                            <div className={"col-12"}>
                                                <input
                                                    id={"choose-tariff-model-autocomplete-city"}
                                                    type="text"
                                                    className="form-control rounded-0 mb-3 serif-bold autoselect-input"
                                                    {...inputProps}
                                                />
                                            </div>
                                        )}
                                        wrapperProps={{className: "row autoselect-wrapper d-block position-relative"}}
                                        renderMenu={(items, value, style) =>
                                            <div className={"col-12"} style={{
                                                marginTop: '0px',
                                                left: '0',
                                                right: '0px',
                                                position: 'absolute',
                                                width: 'auto',
                                                zIndex: '100',
                                                paddingRight: '15px',
                                                top: '38px'
                                            }}>
                                                <div style={{overflowY: 'auto', height: '140px'}} children={items}/>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-12 col-lg-6 col-xl-5">
                                    <h3 className="text-white serif-bold lead-text mt-3 mt-lg-0"> {TranslationService.translate(CHOOSE_MUNICIPALITY, this.props.lang)} </h3>

                                    <Autocomplete
                                        value={this.props.selectedMunicipalityName}
                                        onChange={(e) => this.props.setSelectedMunicipalityName(e.target.value)}
                                        onSelect={(value, item) => {
                                            this.props.selectMunicipality(item.id)
                                        }}
                                        getItemValue={(item) => item.label}
                                        items={this.props.autocompleteMunicipalities.map(m => {
                                            return {id: m.id, label: this.translateName(m)}
                                        })}
                                        renderItem={(item, isHighlighted) =>
                                            <div className="p-1" key={'mun' + item.id}
                                                 style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                                                <span style={{paddingLeft: "8px"}}> {item.label} </span>
                                            </div>
                                        }
                                        renderInput={(inputProps) => (
                                            <div className={"col-12"}>
                                                <input
                                                    type="text"
                                                    disabled={!this.props.selectedCity}
                                                    id={"choose-tariff-model-autocomplete-municipality"}
                                                    className="form-control rounded-0 mb-3 serif-bold autoselect-input"
                                                    {...inputProps}
                                                />
                                            </div>
                                        )}
                                        wrapperProps={{className: "row autoselect-wrapper d-block position-relative"}}
                                        renderMenu={(items, value, style) =>
                                            <div className={"col-12"} style={{
                                                marginTop: '0px',
                                                left: '0',
                                                right: '0px',
                                                position: 'absolute',
                                                width: 'auto',
                                                zIndex: '100',
                                                paddingRight: '15px',
                                                top: '38px',
                                                marginRight: '0'
                                            }}>
                                                <div style={{overflowY: 'auto', height: '140px'}} children={items}/>
                                            </div>
                                        }
                                    />

                                </div>

                            </div>
                        </div>
                        <div className="col-12 text-center mt-5">

                            <h3 className="text-white serif-bold lead-text"> {TranslationService.translate(CHOOSE_TARIFF, this.props.lang)} </h3>

                            <div className="tariff_models bg-white">
                                <div
                                    className="row d-none d-md-flex align-items-center justify-content-center h-100 sans-regular text-center">

                                    <TariffTypes tariffTypes={this.props.tariffTypes}
                                                 tariffModelShortNames={this.props.tariffModelShortNames}
                                                 selectedMunicipality={this.props.selectedMunicipality}
                                                 selectTariffModel={(tm) => this.selectTariffModel(tm)}/>

                                </div>

                                <TariffTypesMobile tariffTypes={this.props.tariffTypes}
                                                   tariffModelShortNames={this.props.tariffModelShortNames}
                                                   selectTariffType={(tt) => this.selectTariffType(tt)}
                                                   selectTariffModel={(tm) => this.selectTariffModel(tm)}
                                                   selectedTariffType={this.state.selectedTariffType}
                                                   tariffModels={this.state.tariffModels}
                                                   selectedCity={this.props.selectedCity}
                                                   selectedMunicipality={this.props.selectedMunicipality}
                                                   lang={this.props.lang}/>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        );
    }

    selectTariffType(value) {
        if (this.props.selectedMunicipality) {
            const tariffType = this.props.tariffTypes.find(tt => tt.tariffType.id == value);
            this.setState({
                selectedTariffType: isNaN(value) ? null : value,
                tariffModels: tariffType ? tariffType.tariffModels : []
            })
        }
    }

    selectTariffModel(tm) {
        if (this.props.selectedMunicipality) {

            const selectedTariffType = this.state.selectedTariffType ? this.state.selectedTariffType : this.props.tariffTypes.find(tt => {
                return tt.tariffModels.map(tm => tm.id).includes(tm);
            }).tariffType.id;

            let search = `${this.props.location.search}&tariffType=${selectedTariffType}&tariffModel=${tm}`

            if (!isNaN(tm)) {
                this.props.history.push({pathname: '/tv-channels', search: search});
            }
        }
    }

    translateName(obj) {
        if (this.props.lang === 'en_US') {
            return obj.nameEN
        } else if (this.props.lang === 'sq_AL') {
            return obj.nameAL
        } else return obj.nameMK
    }

}

export default ChooseTariffModel;
